import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_332kmgihxr: FaireBrandEntity = {
  token: "b_332kmgihxr",
  type: "brand",
  name: "Ula Bloom",
  avatarUrl: "https://cdn.faire.com/fastly/9ec5d62906ee584a35f8921d7295ab322efc0a7bbceef0d31de2beb3e28cf0cf.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/dc65fb62aa18f084db1172d95496d57b70cb79daf52e6ae109b643d435aaac04.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/9ec5d62906ee584a35f8921d7295ab322efc0a7bbceef0d31de2beb3e28cf0cf.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/dc65fb62aa18f084db1172d95496d57b70cb79daf52e6ae109b643d435aaac04.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 19,
  isTopShop: true,
  isInsider: true,
  description: "Ula Bloom is a NYC-based stationery and lifestyle brand with a passion for paint and a heart for people. Our vibrant collection of greeting cards are created to inspire and uplift.\n\nAt Ula Bloom we’re dedicated to helping others dream, grow, and BLOOM into their full potential. Through our partnership with the non-profit Room to Read, every purchase supports literacy education for children in need.\n\nTogether, we’re making a difference in young lives around the globe.\n\nJoin us on this colorful journey as we inspire growth, and cultivate a brighter future—one card, one gift, one child at a time.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:01.967Z",
    importedBy: "entity-db-cli"
  }
};
